const baseUrl = {
    pro: 'https://vocabulary-api.freyhill.com',
    dev: 'http://localhost:1897'
}

const host = window.location.host;

const env = /localhost/.test(host) ? baseUrl.dev: baseUrl.pro;
export default env;